import { useRandomSigninBackgroundImage } from "@/Helpers/randomBackgroundImage";
import { AuthenticationAcceptInvitation } from "./CustomComponents/AuthenticationAcceptInvitation";
import { AuthenticationScreenContainer } from "./CustomComponents/AuthenticationScreenContainer";

function AcceptInvitationScreen() {
  const backgroundImage = useRandomSigninBackgroundImage();

  return (
    <AuthenticationScreenContainer imageUrl={backgroundImage}>
      <AuthenticationAcceptInvitation />
    </AuthenticationScreenContainer>
  );
}
export default AcceptInvitationScreen;
